import Logger from 'services/Logger'

export const ensureVersionValid = (version?: string) => {
	if (!version) return ''
	if (RegExp(/^(?:\/v\/\d{4})|(?:\/snapshot\/[a-f0-9]{7})$/).test(version)) {
		return version
	}
	console.log('Ignoring override because of REGEX failure')
	Logger.error('Ignoring override because of REGEX failure')
	return ''
}
